"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSlideCross(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#919499",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.646 36.647a.5.5 0 00.708.707L19 19.707l17.647 17.647a.5.5 0 00.707-.707L19.707 19 37.354 1.354a.5.5 0 00-.707-.708L19 18.293 1.354.646a.502.502 0 00-.708.708L18.293 19 .646 36.647z"
  }));
}

var MemoSvgSlideCross = /*#__PURE__*/React.memo(SvgSlideCross);
var _default = MemoSvgSlideCross;
exports["default"] = _default;